import { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Box,
  Button
} from "@mui/material";

export default function Settings() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [ageGroup, setAgeGroup] = useState("");
  const [gender, setGender] = useState("");
  const [birthMonth, setBirthMonth] = useState("");
  const [hobbies, setHobbies] = useState<string[]>([]);
  const [pets, setPets] = useState<string[]>([]);

  const hobbyOptions = ["読書", "映画", "音楽", "アイドル", "アウトドア", "金融"];
  const petOptions = ["飼っていない", "犬", "猫", "爬虫類", "昆虫"];

  const handleCheckboxChange = (list: string[], setList: (v: string[]) => void, value: string) => {
    if (list.includes(value)) {
      setList(list.filter((item) => item !== value));
    } else {
      setList([...list, value]);
    }
  };

  const handleSave = () => {
    console.log({
      email,
      password,
      ageGroup,
      gender,
      birthMonth,
      hobbies,
      pets
    });
    alert("保存しました！");
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        個人設定
      </Typography>

      {/* メールアドレス */}
      <TextField
        fullWidth
        label="メールアドレス"
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      {/* パスワード */}
      <TextField
        fullWidth
        label="パスワード"
        type="password"
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      {/* 年代 */}
      <FormControl sx={{ mt: 2 }}>
        <FormLabel>年代</FormLabel>
        <RadioGroup
          row
          value={ageGroup}
          onChange={(e) => setAgeGroup(e.target.value)}
        >
          {["10代", "20代", "30代", "40代", "50代", "60代", "70代"].map((age) => (
            <FormControlLabel key={age} value={age} control={<Radio />} label={age} />
          ))}
        </RadioGroup>
      </FormControl>

      {/* 性別 */}
      <FormControl sx={{ mt: 2 }}>
        <FormLabel>性別</FormLabel>
        <RadioGroup
          row
          value={gender}
          onChange={(e) => setGender(e.target.value)}
        >
          <FormControlLabel value="男性" control={<Radio />} label="男性" />
          <FormControlLabel value="女性" control={<Radio />} label="女性" />
        </RadioGroup>
      </FormControl>

      {/* 誕生月 */}
      <FormControl sx={{ mt: 2 }}>
        <FormLabel>誕生月</FormLabel>
        <RadioGroup
          row
          value={birthMonth}
          onChange={(e) => setBirthMonth(e.target.value)}
        >
          {[...Array(12)].map((_, i) => (
            <FormControlLabel
              key={i + 1}
              value={(i + 1).toString()}
              control={<Radio />}
              label={`${i + 1}`}
            />
          ))}
        </RadioGroup>
      </FormControl>

      {/* 趣味 */}
      <Box sx={{ mt: 2 }}>
        <FormLabel>趣味</FormLabel>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {hobbyOptions.map((hobby) => (
            <FormControlLabel
              key={hobby}
              control={
                <Checkbox
                  checked={hobbies.includes(hobby)}
                  onChange={() => handleCheckboxChange(hobbies, setHobbies, hobby)}
                />
              }
              label={hobby}
            />
          ))}
        </Box>
      </Box>

      {/* ペット */}
      <Box sx={{ mt: 2 }}>
        <FormLabel>ペット</FormLabel>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {petOptions.map((pet) => (
            <FormControlLabel
              key={pet}
              control={
                <Checkbox
                  checked={pets.includes(pet)}
                  onChange={() => handleCheckboxChange(pets, setPets, pet)}
                />
              }
              label={pet}
            />
          ))}
        </Box>
      </Box>

      {/* 保存ボタン */}
      <Button variant="contained" sx={{ mt: 3 }} onClick={handleSave}>
        保存
      </Button>
    </Container>
  );
}
